import { Stack } from '@mui/material';

import { ScrollableContent } from '@/components/scroll/scrollableContent';
import { ScrollableWrapper } from '@/components/scroll/scrollableContext';
import { ScrollableHeader } from '@/components/scroll/scrollableHeader';

import { SelectedItemsBody } from './selectedItemsBody';
import { SelectedItemsHeader } from './selectedItemsHeader';

export const SelectedItemsBox = <T,>({
  items,
  entityType,
  renderItem,
  itemKey,
  onRemove,
  clearAll,
}: {
  items: T[];
  entityType: string;
  renderItem: (item: T) => React.ReactNode;
  itemKey: (item: T) => string;
  onRemove: (item: T) => void;
  clearAll: () => void;
}) => {
  return (
    <Stack className='overflow-hidden'>
      <ScrollableWrapper>
        <ScrollableHeader hideBorderWhenOnTop>
          <Stack padding='0 24px 12px'>
            <SelectedItemsHeader
              title={`${items.length} ${items.length === 1 ? entityType : `${entityType}${entityType.endsWith('s') ? 'es' : 's'}`} added`}
              clearAll={clearAll}
            />
          </Stack>
        </ScrollableHeader>
        <ScrollableContent>
          <SelectedItemsBody
            items={items}
            renderItem={renderItem}
            itemKey={itemKey}
            onRemove={onRemove}
          />
        </ScrollableContent>
      </ScrollableWrapper>
    </Stack>
  );
};
